import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { get } from 'lodash';
import { connect } from 'react-redux';
import { clearBanner } from '../app-main/actions/banner';

class ReduxBanner extends React.Component {
  render () {
    const {
      banner = {},
      dispatch,
      children
    } = this.props;

    return (
      <div>
        {
          React.Children.map(children, (child) => {
            return child.props.bannerId === banner.bannerId &&
              React.cloneElement(child, {
                closeBanner: () => dispatch(clearBanner())
              });
          })
        }
      </div>
    );
  }
}

ReduxBanner.propTypes = {
  banner: PropTypes.object,
  dispatch: PropTypes.func,
  children: PropTypes.element
};

const mapStateToProps = (state) => {
  const banner = get(state, 'banner', {});
  return {
    banner
  };
};

export default connect(mapStateToProps)(ReduxBanner);
